import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatServiceAddress, getGroupingServiceDateRange } from '@wayste/utils';
import { ClipboardDocumentListIcon } from '@heroicons/react/20/solid';
import { useSourSearchContext } from '../../context/use-sour-search-context';
import { ErrorBoundary } from '../helper/error-boundary';
import { ResultWrapper } from '../helper/result-wrapper';
import UniversalServicesStatusPill from '../helper/universal-services-status-pill';
export const ServiceGroupingResult = ({ grouping, onSelect, }) => {
    const { id, orderNumber } = grouping;
    const { environmentOptions } = useSourSearchContext();
    const status = grouping.serviceOrders.every((serviceOrder) => serviceOrder.cancellationDetails)
        ? 'CANCELLED'
        : grouping.serviceOrders.every((serviceOrder) => serviceOrder.status)
            ? grouping.serviceOrders[0].status
            : 'MIXED';
    const order = {
        serviceGrouping: grouping,
        status: status,
        serviceRange: getGroupingServiceDateRange(grouping).string,
        subscription: grouping.type !== 'single' ? 'Subscription' : 'One Time',
        serviceSKU: [...new Set(grouping.serviceOrders.map((serviceOrder) => serviceOrder.serviceType.family.name))].join(', '),
        address: grouping.serviceOrders.every((serviceOrder) => serviceOrder.serviceLocation)
            ? formatServiceAddress(grouping.serviceOrders[0].serviceLocation?.address)
            : 'Multiple',
        orderNumber: grouping.orderNumber,
        customer: grouping.customerCompanyName || grouping.customerName,
        vendor: grouping.serviceOrders.every((serviceOrder) => !serviceOrder.vendorName)
            ? ''
            : grouping.serviceOrders.every((serviceOrder) => serviceOrder.vendorName)
                ? grouping.serviceOrders[0].vendorName
                : 'Multiple',
    };
    const handleRedirect = () => {
        onSelect(grouping, id, 'serviceGrouping');
    };
    return (_jsx(ErrorBoundary, { children: _jsxs(ResultWrapper, { onRedirect: handleRedirect, children: [_jsx(ClipboardDocumentListIcon, { className: "size-4" }), _jsx("div", { className: "border-l-2 border-gray-300 pl-2", children: orderNumber }), environmentOptions.application !== 'customer-portal' && (_jsx("div", { className: "flex flex-col items-center justify-center overflow-hidden overflow-ellipsis whitespace-nowrap border-l-2 border-gray-300 pl-2", children: _jsx(UniversalServicesStatusPill, { status: status }) })), _jsx("div", { className: "overflow-hidden overflow-ellipsis whitespace-nowrap border-l-2 border-gray-300 pl-2", children: order.address }), _jsx("div", { className: "overflow-hidden overflow-ellipsis whitespace-nowrap border-l-2 border-gray-300 pl-2", children: order.serviceSKU })] }) }));
};
//# sourceMappingURL=service-grouping-result.js.map